import { useEffect, useRef, useState } from "react";
// import Pagination from "../../Components/Pagination";

import { useContext } from "react";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  faPenToSquare,
  faTrash,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "./Pagination";

import Loader from "../Loader";
import { deleteWithAuthCall, getRequest, multipartPostCallWithErrorResponse, PostCallWithErrorResponseReqBody, postRequest, postWithAuthCall, simpleGetCallWithToken, simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { ToastMsg } from "../TostMsg";
import NoDataFound from "./NodataFound";
import CommonButton from "./button";
import { AppContext } from "../../context/AppContext";
import { downloadFile } from "./commaon";
import Modal from 'react-bootstrap/Modal';
import SelectDomain from "../../component/SelectDomain";

export default function TestCases() {
  const [conversationalFlowList, setConversationalFlowList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef(null);
  const [isDownload, setIsDownload] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [total, setTotal] = useState(0)

  const [selectedCases, setSelectedCases] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [modulename, setmodulename] = useState("");
  const [submodulename, setSubmodulename] = useState("");

  // Function to handle selecting/unselecting a single test case
  const handleSelectCase = (testCaseId) => {
    setSelectedCases((prevSelected) =>
      prevSelected.includes(testCaseId)
        ? prevSelected.filter((id) => id !== testCaseId) // Remove if already selected
        : [...prevSelected, testCaseId] // Add if not selected
    );
  };

  // Function to handle selecting/unselecting all test cases
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCases([]); // Deselect all
    } else {
      setSelectedCases(conversationalFlowList.map((item) => item.test_case_id)); // Select all
    }
    setSelectAll(!selectAll);
  };













  const {
    isDrawerOpen,
    selectedDomainId,
    domainName,
    setBackTo,
    sidebar,
    setEditKeyWordDtls,
    permissions
  } = useContext(AppContext);



  const getList = () => {
    simpleGetCallWithToken(
      `${ApiConfig?.TEST_CASE_LIST}?domain_id=${selectedDomainId}&page=${currentPage}&page_limit=25&module_name=${modulename}&sub_modulename=${submodulename}`
    )
      .then((res) => {
        if (res?.success) {
          setConversationalFlowList(res?.data);
          setTotal(res?.total_records)
          setTotalPage(res?.total_pages)

          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);

    getList();
  }, [selectedDomainId, modulename, submodulename, currentPage]);





  const navigate = useNavigate();


  const deleteQuestion = (id) => {
    deleteWithAuthCall(ApiConfig.TEST_CASE_DELETE + id)
      .then((res) => {
        if (res?.success) {
          ToastMsg("success", res?.message);

          getList()
        } else {
          ToastMsg("error", res?.message);
        }
      })
      .catch((err) => {
        ToastMsg("error", "Something Went Wrong Try Again");
      });
  };


  const downLoadQuesList = () => {


    const body = {
      domain_id: "5",

    };
    postRequest(ApiConfig?.TEST_EXPORT, JSON.stringify(body)).then((res) => {

      if (res?.success) {

        downloadFile({
          data: JSON.stringify(res?.data),
          fileName: 'cases.json',
          fileType: 'text/json',
        })


      } else {

        ToastMsg('error', res?.Message)

      }



    }).catch((err) => {

      console.log(err);


    })


  }






  const uploadExcell = (e) => {
    setIsLoading(true);

    let file = e.target.files[0];

    console.log(file);

    let formData = new FormData();
    formData.append("domain_id", selectedDomainId);
    formData.append("file", e.target.files[0]);

    multipartPostCallWithErrorResponse(ApiConfig.TEST_CASE_IMPORT, formData)
      .then((res) => {
        console.log(res)
        if (res?.json.success) {
          ToastMsg("success", res?.json.message);
          clearFileInput();
          getList();
          setIsLoading(false);
        } else {
          ToastMsg("error", res?.json.message);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        ToastMsg("error", "Something Went Wrong");

        setIsLoading(false);
      });
  };

  const clearFileInput = () => {
    ref.current.value = null;
  };

  const [show, setShow] = useState(false);
  const [filteredData, setFilteredData] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = (eve) => {
    setShow(true);
    console.log(eve);
    setFilteredData(eve);
  }

  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div>
        <div>
          <div className="role-content">
            <div className="sub-header-role d-flex justify-content-between">
              <h6 className="mt-2">Test Cases</h6>
              <div className="d-flex">
                <h6 className="mt-2">Domain Name : {domainName}</h6>
                <SelectDomain />
              </div>
            </div>
            <div className="d-flex justify-content-between mt-4">
              <div className="d-flex input_wraper">

                <input type="input"

                  onChange={(e) => {
                    setmodulename(

                      e.target.value,
                    );

                  }}
                  value={modulename}

                  placeholder="Enter Module Name"
                />


                <input className="me-2 mr-2" type="input"
                  onChange={(e) => {
                    setSubmodulename(

                      e.target.value,
                    );

                  }}
                  value={submodulename}

                  placeholder="Enter sub module Name"
                />
              </div>
              <div>
                <input
                  type="file"
                  name=""
                  id=""
                  style={{ display: "none" }}
                  ref={ref}
                  accept=".xls,.xlsx"
                  onChange={uploadExcell}
                />


                {
                  permissions && permissions['Import Test Cases'] &&
                  <button
                    className="AddQuestion_submit_btn mx-3"
                    onClick={() => {
                      ref.current.click();
                    }}
                  >
                    Import Test Cases
                    {" "}
                  </button>
                }
                {
                  permissions && permissions['Publish Test Cases'] &&
                  <button className="AddQuestion_submit_btn mx-3 " type="button" disabled={isDownload} onClick={downLoadQuesList}>Publish</button>
                }
                {
                  permissions && permissions['Create Test Cases'] &&
                  <button className="AddQuestion_submit_btn mx-3 " type="button"
                    onClick={() => {
                      navigate("/EditCase");
                    }}

                  >Add Test Cases</button>
                }

              </div>
            </div>
            <div className="table-wrapper table-wrapper-2" style={{ height: "750px" }}>
              {isLoading ? (
                <Loader />
              ) : conversationalFlowList.length > 0 ? (
                <table style={{ marginBottom: "20px" }}>
                  <thead>
                    <tr className="firstTabelRow">
                      <th>
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th>Sr. no</th>
                      <th>Test Module</th>
                      <th>Test Sub Module</th>
                      <th>Intent</th>
                      <th>Predecessor Test Case</th>
                      <th>Successor Test Case</th>
                      <th>Test Case ID</th>
                      <th>Test Case Type</th>
                      <th>Test Key Features</th>
                      <th>Pre-Conditions</th>
                      <th>Test Steps</th>
                      <th>Test Data</th>
                      <th>Test Case Description</th>
                      <th>Expected Results</th>
                      <th>Actual Results</th>
                      <th>Post Conditions</th>
                      <th>Pass/Fail Criteria</th>
                      {
                        permissions && (permissions['Delete Test Cases'] || permissions['Edit Test Cases']) &&
                        <th style={{ position: "sticky", right: "-10px", top: "0", zIndex: "99", background: "white" }}>Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {conversationalFlowList.map((item, index) => (
                      <tr key={index} className="table-row-custom">
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedCases.includes(item.test_case_id)}
                            onChange={() => handleSelectCase(item.test_case_id)}
                          />
                        </td>
                        <td>{index + 1}</td>
                        <td>{item?.test_module}</td>
                        <td>{item?.test_sub_module}</td>
                        <td>{item?.intent ? item.intent.slice(0, 20) + "..." : "N/A"}</td>
                        <td ><Link to={`/WorkFlowChartss/${item.test_case_code_id}`}>{item?.predecessor_test_case ? item.predecessor_test_case.slice(0, 20) + "..." : "N/A"}</Link></td>
                        <td>{item?.successor_test_case ? item.successor_test_case.slice(0, 20) + "..." : "N/A"}</td>
                        <td>{item?.test_case_code_id}</td>
                        <td>{item?.test_case_type}</td>
                        <td>{item?.test_key_features}</td>
                        <td>{item?.pre_conditions ? item.pre_conditions.slice(0, 20) + "..." : "N/A"}</td>
                        <td >{item?.test_steps ? item.test_steps.slice(0, 20) + "..." : "N/A"}</td>
                        <td >{item?.test_data ? item.test_data.slice(0, 25) + "..." : "N/A"}</td>
                        <td>{item?.test_case_description ? item.test_case_description.slice(0, 20) + "..." : "N/A"}</td>
                        <td >{item?.expected_results ? item.expected_results.slice(0, 20) + "..." : "N/A"}</td>



                        <td>{item?.actual_results}</td>
                        <td>{item?.post_conditions}</td>
                        <td>{item?.pass_fail_criteria}</td>
                        {
                          permissions && (permissions['Delete Test Cases'] || permissions['Edit Test Cases']) &&
                          <td style={{ position: "sticky", right: "-10px", zIndex: "1", background: "white" }}>
                            {
                              permissions && permissions['Edit Test Cases'] &&

                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 100, hide: 300 }}
                                overlay={(props) => (
                                  <Tooltip id="button-tooltip" {...props}>Edit Test Cases</Tooltip>
                                )}
                              >
                                <FontAwesomeIcon
                                  onClick={() => {
                                    navigate("/EditCase");
                                    setEditKeyWordDtls(item.test_case_id);
                                  }}
                                  icon={faPenToSquare}
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    marginRight: "10px",
                                  }}
                                />
                              </OverlayTrigger>
                            }
                            {
                              permissions && permissions['Delete Test Cases'] &&
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 100, hide: 300 }}
                                overlay={(props) => (
                                  <Tooltip id="button-tooltip" {...props}>Delete</Tooltip>
                                )}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  style={{ width: "15px", height: "15px" }}
                                  onClick={() => deleteQuestion(item?.test_case_id)}
                                />
                              </OverlayTrigger>
                            }
                          </td>
                        }
                      </tr>
                    ))}

                  </tbody>
                </table>
              ) : (
                <NoDataFound />
              )}
            </div>
            <Pagination
              totalPage={Number(totalPage)}
              currentPage={currentPage}
              pageChangeHandler={(page) => setCurrentPage(page + 1)}
            />

            <Modal centered show={show} onHide={handleClose} className="">
              <Modal.Header closeButton>
                <Modal.Title>View</Modal.Title>
              </Modal.Header>
              <Modal.Body className="pt-2 border-top">{filteredData}</Modal.Body>
              {/* <Modal.Footer>
          <button variant="secondary" onClick={handleClose}>
            Close
          </button>
          <button variant="primary" onClick={handleClose}>
            Save Changes
          </button>
        </Modal.Footer> */}
            </Modal>
          </div>
        </div>

      </div>
    </div>
  );
}
